<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-xs-12">
			<label>{{TR "Name"}}</label>
			<input id="js-name-input" class="form-control js-name" type="text" name="name" placeholder="{{TR "Name"}}" value="{{name}}">
		</div>
	</div>
	<div class="row">
		<div class="col-xs-12">
			<label class=" m-t-20">{{TR "E-Mail Adressen / Telefonnummern"}}</label>
		</div>
	</div>
	{{#each targetList}}
	<div class="row">
		<div class="col-xs-11 m-b-10">
			<input id="js-target-{{@index}}-input" class="form-control js-target"
				type="text" name="target" placeholder="{{TR "E-Mail"}} / {{TR "Telefonnummer"}}" value="{{this}}">
		</div>
		<div class="col-xs-1">
			<button type="button" id="js-delete-{{@index}}" class="btn btn-medium btn-white js-delete pull-right"><i class="fa fa-trash"></i></button>
		</div>
	</div>
	{{/each}}
	<div class="row">
		<div class="col-xs-11">
			<input class="js-target js-add-target form-control"></input>
		</div>
		<div class="col-xs-1">
			<button type="button" class="js-add-target btn btn-medium btn-white pull-right">
				<i class="fa fa-plus"></i>
			</button>
		</div>
	</div>

	<div class="checkbox checkbox-primary m-t-20">
		<input id="js-privacy-input" type="checkbox" {{#if termsAccepted}}checked="true" {{/if}}name="accept terms">
		<label for="js-privacy-input">
			{{TR "Datenverarbeitungshinweis zur Kenntnis genommen"}}.
		</label>
		<div class="allert m-t-20">
			<div id="js-terms-text" class="card-box {{#if termsAccepted}}box-color-success{{else}}box-color-info{{/if}}">
				{{TR "Ich habe die Befugnis, die gemachten Angaben allen Administratoren zur Verfügung zu stellen. Alle unter den obigen E-Mail-Adressen / Telefonnummern erreichbaren Personen sind mit der Freigabe einverstanden. Die Daten werden ausschließlich zur Funktionserfüllung verwendet, es erfolgt keine Weitergabe der Daten an Dritte."}}
			</div>
		</div>
	</div>
</div>

<div class="modal-footer">
    <button id="ct-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Abbrechen"}}
    </button>
    <button class="btn btn-primary" id="js-btn-save">
        {{TR "Speichern"}}
    </button>
</div>
